<div class="relative w-full">
  <div class="w-full relative p-3 text-sm font-medium text-center block sm:flex text-gray-500 bg-white border border-gray-200 rounded-lg shadow-sm dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700 sm:p-4">

    <div *ngIf="showArrows" class="inset-y-0 flex items-center justify-between pointer-events-none hidden sm:flex">
      <div class="pointer-events-auto">
        <ui-button [icon]="EIcon.AngleLeft" [size]="EComponentSize.Large" [type]="EAlert.INFO" (action)="scrollLeft()" class="p-2"></ui-button>
      </div>
      <div class="pointer-events-auto">
        <ui-button [icon]="EIcon.AngleRight" [size]="EComponentSize.Large" [type]="EAlert.INFO" (action)="scrollRight()" class="p-2"></ui-button>
      </div>
    </div>

    <div #carousel class="overflow-x-auto scroll-smooth flex w-full space-x-2 sm:space-x-4 whitespace-nowrap no-scrollbar">
      <ol class="flex items-center w-full">
        <li *ngFor="let item of steps(); index as i"
            [class.text-blue-600]="currentStep() === i"
            [class.dark:text-blue-500]="currentStep() === i"
            (click)="onTab($event, i)"
            class="flex items-center cursor-pointer shrink-0 px-3 last:mr-12">

          <span class="flex items-center justify-center w-6 h-6 me-2 text-xs font-bold border border-blue-600 rounded-full shrink-0 dark:border-blue-500 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300">
            {{ i + 1 }}
          </span>
          {{ item.name }}

          <svg *ngIf="i < steps().length - 1" class="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m7 9 4-4-4-4M1 9l4-4-4-4" />
          </svg>
        </li>
      </ol>
    </div>

  </div>
</div>
